import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './dialog';
import { Button } from './button';
import { Field, Label } from './fieldset';
import { Select } from './select';
import FileReceiver from './FileReceiver';
import { DocumentIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ConvenioContractDialog = ({
  isOpen,
  onClose,
  onSubmit,
  beneficiarios = [],
  proyectos = [],
  loading,
}) => {
  const [beneficiarioId, setBeneficiarioId] = useState('');
  const [proyectoId, setProyectoId] = useState('');
  const [contractFile, setContractFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!beneficiarioId || !contractFile) return;

    await onSubmit({
      beneficiarioId,
      proyectoId: proyectoId || null,
      contractFile,
    });

    resetForm();
  };

  const resetForm = () => {
    setBeneficiarioId('');
    setProyectoId('');
    setContractFile(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Nuevo Contrato</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogBody>
          <div className="space-y-4">
            <Field>
              <Label>Beneficiario</Label>
              <Select
                value={beneficiarioId}
                onChange={(e) => setBeneficiarioId(e.target.value)}
                required
              >
                <option value="">Seleccionar beneficiario...</option>
                {beneficiarios.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.nombre} {b.rfc ? `(${b.rfc})` : ''}
                  </option>
                ))}
              </Select>
            </Field>
            {proyectos.length > 0 && (
              <Field>
                <Label>Proyecto (opcional)</Label>
                <Select
                  value={proyectoId}
                  onChange={(e) => setProyectoId(e.target.value)}
                >
                  <option value="">Sin proyecto</option>
                  {proyectos.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.nombre}
                    </option>
                  ))}
                </Select>
              </Field>
            )}

            {/* Contract file upload */}
            <Field>
              <Label>Contrato (PDF)</Label>
              {contractFile ? (
                <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <DocumentIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-green-800 truncate">
                      {contractFile.name}
                    </p>
                    <p className="text-xs text-green-600">
                      {(contractFile.size / 1024).toFixed(0)} KB
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => setContractFile(null)}
                    className="p-1 rounded-full hover:bg-green-100 transition-colors"
                  >
                    <XMarkIcon className="h-4 w-4 text-green-600" />
                  </button>
                </div>
              ) : (
                <FileReceiver
                  title="Arrastra o selecciona el contrato"
                  type="pdf"
                  maxFiles={1}
                  onFilesChange={(files) => {
                    if (files && files.length > 0) {
                      setContractFile(files[0]);
                    }
                  }}
                />
              )}
            </Field>
          </div>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={handleClose} type="button">
            Cancelar
          </Button>
          <Button type="submit" disabled={!beneficiarioId || !contractFile || loading}>
            {loading ? 'Creando...' : 'Crear Contrato'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ConvenioContractDialog;
